"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.repayPerpetualLoanTest = void 0;
const constants_1 = require("../../../../constants");
const helpers_1 = require("../../../../helpers");
const types_1 = require("../../../../types");
const offer_1 = require("../../offer");
const anchor_1 = require("@project-serum/anchor");
const token_1 = require("@project-serum/anchor/dist/cjs/utils/token");
const repayPerpetualLoanTest = ({ programId, connection, args, accounts, addComputeUnits, sendTxn, }) => __awaiter(void 0, void 0, void 0, function* () {
    const program = (0, helpers_1.returnAnchorProgram)(programId, connection);
    const instructions = [];
    const [mutualBondTradeTxnVault] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.MUTUAL_BOND_TRADE_TXN_VAULT)], program.programId);
    const [oldBondOfferVault, oldBondOfferVaultBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BOND_OFFER_VAULT_PREFIX), accounts.oldBondOffer.toBuffer()], program.programId);
    const repayRemainingAccounts = (yield Promise.all(args.repayAccounts.map((repayAccount) => __awaiter(void 0, void 0, void 0, function* () {
        return [
            {
                pubkey: repayAccount.bondTradeTransaction,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: repayAccount.lender,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: repayAccount.fbond,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: accounts.protocolFeeReceiver,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: accounts.oldBondOffer,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: oldBondOfferVault,
                isSigner: false,
                isWritable: true,
            },
        ];
    })))).flat();
    const modifyComputeUnits = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
        units: Math.round(800000 + Math.ceil(Math.random() * 10000)),
    });
    const requestHeap = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({ microLamports: 6000 });
    instructions.push(requestHeap);
    if (!!addComputeUnits)
        instructions.push(modifyComputeUnits);
    instructions.push(yield program.methods
        .repayPerpetualLoanTest()
        .accountsStrict({
        mutualBondTradeTxnVault: mutualBondTradeTxnVault,
        user: accounts.userPubkey,
        systemProgram: anchor_1.web3.SystemProgram.programId,
        rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
        tokenProgram: token_1.TOKEN_PROGRAM_ID,
    })
        .remainingAccounts([...repayRemainingAccounts])
        .instruction());
    const transaction = new anchor_1.web3.Transaction();
    for (let instruction of instructions)
        transaction.add(instruction);
    const remainingAccounts = [
        ...repayRemainingAccounts.map((sellBondRemainingAccount) => sellBondRemainingAccount.pubkey),
    ];
    const addressesForLookupTable = [...remainingAccounts];
    const signers = [];
    yield sendTxn(transaction, signers);
    const optimisticResults = args.repayAccounts.map((repayParams) => {
        var _a;
        const fullLoanBody = repayParams.optimistic.bondTradeTransaction.solAmount + repayParams.optimistic.bondTradeTransaction.feeAmount;
        const now = (0, offer_1.nowInSeconds)();
        const interestSol = (0, offer_1.calculateCurrentInterestSolPure)({
            loanValue: fullLoanBody,
            startTime: repayParams.optimistic.bondTradeTransaction.soldAt,
            currentTime: now,
            rateBasePoints: repayParams.optimistic.bondTradeTransaction.amountOfBonds,
        });
        const amountToReturn = fullLoanBody + interestSol;
        const updatedBond = (0, offer_1.optimisticRepayFraktBond)(repayParams.optimistic.fraktBond, amountToReturn);
        const updatedOldBondTradeTransaction = (0, offer_1.optimisticRepayBondTradeTransaction)(repayParams.optimistic.bondTradeTransaction, false, types_1.RedeemResult.DirectRepaid, (0, offer_1.getRepaymentDestination)((_a = repayParams.optimistic.oldBondOffer) === null || _a === void 0 ? void 0 : _a.pairState, repayParams.optimistic.bondTradeTransaction.bondTradeTransactionState
            != types_1.BondTradeTransactionV2State.PerpetualManualTerminating));
        const updatedOldBondOffer = repayParams.optimistic.oldBondOffer
            ? (0, offer_1.optimisticRepayUpdateBondingBondOffer)(repayParams.optimistic.oldBondOffer, fullLoanBody, interestSol, false, repayParams.optimistic.bondTradeTransaction.bondTradeTransactionState !==
                types_1.BondTradeTransactionV2State.PerpetualManualTerminating)
            : repayParams.optimistic.oldBondOffer;
        return {
            fraktBond: updatedBond,
            bondTradeTransaction: updatedOldBondTradeTransaction,
            oldBondOffer: updatedOldBondOffer,
        };
    });
    return { account: null, instructions, signers, addressesForLookupTable, optimisticResults };
});
exports.repayPerpetualLoanTest = repayPerpetualLoanTest;
